<template>
    <modal :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `${endpoint}/${inputs.id}` : endpoint'>

                  <app-note :title="$t('note_naming_series_form_title')"
                  note-type="note-warning" :notes="[$t('note_naming_series_form_text')]" content-type="html"/>


                  <app-input id="inputs_namespace"
                        class="col-sm-9"
                        type="hidden"
                        v-model="inputs.namespace"
                        :required="true"/><br/>

                <div class="form-group row align-items-center">
                    <label for="inputs_model" class="col-sm-3 mb-0">
                        {{ $t('model') }}
                    </label>
                    <app-input
                        id="inputs_model"
                        class="col-sm-9"
                        type="advance-search-select"
                        :loaded-per-time="10"
                        v-model="inputs_model"
                        @input="setModelValue"
                        fetch-url="system/app-model"
                        placeholder="Model"
                        list-value-field="model"
                    />
                </div>

                <div class="form-group row align-items-center">
                    <label for="inputs_prefix" class="col-sm-3 mb-0">
                        {{ $t('prefix') }}
                    </label>
                    <app-input id="inputs_prefix"
                        class="col-sm-9"
                        type="text"
                        v-model="inputs.prefix"
                        :placeholder="$t('prefix')"
                        :required="true"/>
                </div>
                <!-- <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="email"
                               v-model="inputs.email"
                               :placeholder="$t('email_type_input')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/> -->
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
    import {ModalMixin} from "../../../../Mixins/ModalMixin";

    export default {
        name: "ModalForm",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            formId: String,
            endpoint: String,
            value: {
                type: Object,
                default: () => {
                    return {
                        namespace: '',
                        model: '',
                        prefix: ''
                    }
                }
            }
        },
        data() {
            return {
                inputs_model: {
                    id: 0,
                    model: '',
                    namespace: ''
                },
                preloader: false,
                inputs: this.value,
                // statusLists: [
                //     {id: '', value: "Choose One",},
                //     {id: 'active', value: "Active",},
                //     {id: 'inactive', value: "Inactive",},
                //     {id: 'invited', value: "Invite",},
                // ],
                // genderLists: [
                //     {id: 'male', value: "Male"},
                //     {id: 'female', value: "Female"},
                //     {id: 'other', value: "Other"},
                // ],
                modalId: this.formId,
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
                this.getModel();
            },
            setModelValue(data) {
                this.inputs.model = this.inputs.model;
                if (data && data.hasOwnProperty('model')) {
                    this.inputs_model = data;
                    this.inputs.namespace = data.namespace;
                    this.inputs.model = data.model;
                }

            },
            getModel() {
                if (this.inputs.model)
                {
                    let cls = encodeURIComponent(`${this.inputs.namespace}\\${this.inputs.model}`);
                    let url = `system/app-model/${cls}`;
                    this.axiosGet(url)
                    .then(resp => {
                        this.inputs_model = resp.data;
                    })
                }
            }
        },
    }
</script>
